import React, { useState, useRef, useEffect } from "react";
import { StyledKeeper, StyledEditInput, StyledHoverMenu } from "./styles";
import Textarea from "react-textarea-autosize";
import { sendAppEvent } from "../../../../Utils";
import InlineSVG from "react-inlinesvg";

const Keeper = ({ content, index, setKeepers, keepers, editing, setEditing, rejected, setRejected }) => {
  const editingMe = editing === index;
  const [newContent, setNewContent] = useState(content);
  const [animating, setAnimating] = useState(false);
  const [keeperClass, setKeeperClass] = useState("");
  const [born, setBorn] = useState(false);
  const inputRef = useRef();
  const divRef = useRef();

  useEffect(() => {
    if (divRef.current && !content && !index) {
      setEditing(true);
    }

    setTimeout(() => {
      setBorn(true);
    }, 300);

    return function cleanup() {
      if (editing !== false) setEditing(false);
      if (animating) setAnimating(false);
    };
  }, []);

  useEffect(() => {
    if (editingMe || (index === 0 && newContent === "")) {
      inputRef.current && inputRef.current.focus();
    }
  }, [editingMe]);

  const handleTrashClick = () => {
    if (animating) return false;
    setKeeperClass("killed");
    setAnimating(true);
    setTimeout(() => {
      const newKeepers = keepers.filter((keeper, i) => {
        return keeper !== newContent && i !== index;
      });
      setAnimating(false);
      setKeeperClass("");
      setRejected([...rejected, newContent]);
      sendAppEvent("Brainstorm - Trashed Keeper");
      setKeepers(newKeepers);
    }, 300);
  };

  const handleCopyClick = async () => {
    let blob = new Blob([newContent], { type: "text/plain" });
    let item = new window.ClipboardItem({ "text/plain": blob });
    await navigator.clipboard.write([item]);
    // window.alert("Copied to clipboard");
    sendAppEvent("Brainstorm - Clipboard Keeper");
  };

  const handlePencilClick = () => {
    //show the edit form of this keeper
    setEditing(index);
  };

  const handleChange = (e) => {
    setNewContent(e.target.value);
  };

  const stopEditing = () => {
    setEditing(false);
    let newKeepers = keepers
      .map((keeper, i) => {
        if (i === index) {
          return newContent;
        } else {
          return keeper;
        }
      })
      .filter((keeper) => {
        return keeper !== "";
      });

    setKeepers(newKeepers);
    newContent && sendAppEvent("Brainstorm - Edited Keeper");
  };

  const onKeyPressed = (e) => {
    if (e.keyCode == 13) {
      stopEditing();
    }
  };

  return (
    <StyledKeeper
      className={keeperClass}
      born={born}
    >
      {!editingMe && (
        <StyledHoverMenu>
          <div className="action-icon">
            <InlineSVG
              src="/assets/duplicate.svg"
              height="20"
              width="20"
              onClick={handleCopyClick}
            />
          </div>
          <div className="action-icon">
            <InlineSVG
              src="/assets/pencil.svg"
              height="20"
              width="20"
              onClick={handlePencilClick}
            />
          </div>
          <div className="action-icon">
            <InlineSVG
              src="/assets/delete.svg"
              height="20"
              width="20"
              onClick={handleTrashClick}
            />
          </div>
        </StyledHoverMenu>
      )}
      {!editingMe && <div ref={divRef}>{content}</div>}
      {editingMe && (
        <StyledEditInput>
          <Textarea
            ref={inputRef}
            value={newContent}
            onChange={handleChange}
            onFocus={(e) => e.target.select()}
            onKeyPress={onKeyPressed}
            onBlur={stopEditing}
            placeholder={"Edit me"}
          />
        </StyledEditInput>
      )}
    </StyledKeeper>
  );
};

export default Keeper;
